/** Captured from Clients List Facesheet Print settings modal. */
export const FACESHEET_PRINT_SETTINGS = {
  "sections": [
    {
      "title": "General Information",
      "rows": [
        {
          "value": "CLIENT NAME",
          "label": "CLIENT NAME",
          "priority": "1",
          "checked": true
        },
        {
          "value": "CLIENT ID",
          "label": "CLIENT ID",
          "priority": "2",
          "checked": false
        },
        {
          "value": "FRIST NAME",
          "label": "FIRST NAME",
          "priority": "3",
          "checked": true
        },
        {
          "value": "LAST NAME",
          "label": "LAST NAME",
          "priority": "4",
          "checked": true
        },
        {
          "value": "MIDDLE NAME",
          "label": "MIDDLE NAME",
          "priority": "5",
          "checked": true
        },
        {
          "value": "SEX",
          "label": "SEX",
          "priority": "6",
          "checked": true
        },
        {
          "value": "HOME PHONE",
          "label": "HOME PHONE",
          "priority": "7",
          "checked": false
        },
        {
          "value": "CELL PHONE",
          "label": "CELL PHONE",
          "priority": "8",
          "checked": false
        },
        {
          "value": "DATE OF BIRTH",
          "label": "DATE OF BIRTH",
          "priority": "9",
          "checked": false
        },
        {
          "value": "ADMISSION DATE",
          "label": "ADMISSION DATE",
          "priority": "10",
          "checked": false
        },
        {
          "value": "CLIENT EMAIL ID",
          "label": "CLIENT EMAIL ID",
          "priority": "11",
          "checked": false
        },
        {
          "value": "SOCIAL SECURITY",
          "label": "SOCIAL SECURITY",
          "priority": "12",
          "checked": false
        },
        {
          "value": "ADDRESS",
          "label": "ADDRESS",
          "priority": "13",
          "checked": false
        },
        {
          "value": "ALT ADDRESS",
          "label": "ALTERNATIVE ADDRESS",
          "priority": "53",
          "checked": false
        },
        {
          "value": "COUNTY",
          "label": "COUNTY",
          "priority": "54",
          "checked": false
        },
        {
          "value": "PROFILE PHOTO",
          "label": "PROFILE PHOTO",
          "priority": "14",
          "checked": true
        },
        {
          "value": "SOCIAL SECURITY CARD IMAGE",
          "label": "SOCIAL SECURITY CARD IMAGE",
          "priority": "15",
          "checked": false
        },
        {
          "value": "MARITAL STATUS",
          "label": "MARITAL STATUS",
          "priority": "16",
          "checked": false
        },
        {
          "value": "GUARDIAN",
          "label": "GUARDIAN",
          "priority": "17",
          "checked": false
        },
        {
          "value": "GUARDIAN NAME",
          "label": "GUARDIAN NAME",
          "priority": "18",
          "checked": false
        },
        {
          "value": "GUARDIAN PHONE",
          "label": "GUARDIAN PHONE",
          "priority": "19",
          "checked": false
        },
        {
          "value": "PROXY",
          "label": "PROXY",
          "priority": "20",
          "checked": false
        },
        {
          "value": "PROXY NAME",
          "label": "PROXY NAME",
          "priority": "21",
          "checked": false
        },
        {
          "value": "PROXY PHONE",
          "label": "PROXY PHONE",
          "priority": "22",
          "checked": false
        },
        {
          "value": "PRIMARY LANGUAGE",
          "label": "PRIMARY LANGUAGE",
          "priority": "23",
          "checked": false
        },
        {
          "value": "SECONDARY LANGUAGE",
          "label": "SECONDARY LANGUAGE",
          "priority": "24",
          "checked": false
        },
        {
          "value": "CODE STATUS",
          "label": "CODE STATUS",
          "priority": "25",
          "checked": false
        },
        {
          "value": "ETHNICITY",
          "label": "ETHNICITY",
          "priority": "26",
          "checked": false
        },
        {
          "value": "RELIGION",
          "label": "RELIGION",
          "priority": "27",
          "checked": false
        },
        {
          "value": "PROGRAM NAME",
          "label": "PROGRAM NAME",
          "priority": "28",
          "checked": false
        },
        {
          "value": "COMMENTS",
          "label": "COMMENTS",
          "priority": "29",
          "checked": false
        },
        {
          "value": "SPOUSE'S/SIGNIFICANT OTHER'S NAME",
          "label": "SPOUSE'S/SIGNIFICANT OTHER'S NAME",
          "priority": "30",
          "checked": false
        },
        {
          "value": "AGE",
          "label": "AGE",
          "priority": "52",
          "checked": false
        },
        {
          "value": "MOBILITY ID #",
          "label": "MOBILITY ID #",
          "priority": "55",
          "checked": false
        },
        {
          "value": "VETERAN",
          "label": "VETERAN",
          "priority": "56",
          "checked": false
        },
        {
          "value": "RESIDENCE STATUS",
          "label": "RESIDENCE STATUS",
          "priority": "57",
          "checked": false
        }
      ]
    },
    {
      "title": "Additional Information",
      "rows": [
        {
          "value": "ALLERGIES",
          "label": "ALLERGIES",
          "priority": "31",
          "checked": false
        },
        {
          "value": "ADVANCED DIRECTIVES",
          "label": "ADVANCED DIRECTIVES",
          "priority": "32",
          "checked": false
        },
        {
          "value": "HOSPITAL PREFERENCE",
          "label": "HOSPITAL PREFERENCE",
          "priority": "33",
          "checked": false
        },
        {
          "value": "DIAGNOSIS",
          "label": "DIAGNOSIS",
          "priority": "34",
          "checked": false
        },
        {
          "value": "BILLING DIAGNOSIS",
          "label": "BILLING DIAGNOSIS",
          "priority": "35",
          "checked": false
        },
        {
          "value": "DIAGNOSIS DESCRIPTION",
          "label": "DIAGNOSIS DESCRIPTION",
          "priority": "36",
          "checked": false
        },
        {
          "value": "ADDITIONAL HISTORY",
          "label": "ADDITIONAL HISTORY",
          "priority": "37",
          "checked": false
        },
        {
          "value": "MANAGED LONG TERM SERVICE",
          "label": "MANAGED LONG TERM SERVICE",
          "priority": "38",
          "checked": false
        },
        {
          "value": "CASE MANAGER NAME",
          "label": "CASE MANAGER NAME",
          "priority": "39",
          "checked": false
        },
        {
          "value": "CASE MANAGER PHONE",
          "label": "CASE MANAGER PHONE",
          "priority": "40",
          "checked": false
        },
        {
          "value": "CASE MANAGER EMAIL ID",
          "label": "CASE MANAGER EMAIL ID",
          "priority": "41",
          "checked": false
        },
        {
          "value": "PHOTO ID",
          "label": "PHOTO ID",
          "priority": "48",
          "checked": false
        },
        {
          "value": "ELIGIBILITY DATE",
          "label": "ELIGIBILITY DATE",
          "priority": "49",
          "checked": false
        },
        {
          "value": "ENROLLMENT DATE",
          "label": "ENROLLMENT DATE",
          "priority": "50",
          "checked": false
        },
        {
          "value": "WITHDRAWAL DATE",
          "label": "WITHDRAWAL DATE",
          "priority": "51",
          "checked": false
        },
        {
          "value": "EXTENSION",
          "label": "EXTENSION",
          "priority": "42",
          "checked": false
        }
      ]
    },
    {
      "title": "Header Settings :",
      "rows": [
        {
          "value": "HEADER CLIENT NAME",
          "label": "CLIENT NAME",
          "priority": "42",
          "checked": false
        },
        {
          "value": "MEMBER ID",
          "label": "MEMBER ID",
          "priority": "43",
          "checked": false
        },
        {
          "value": "DOB",
          "label": "DOB",
          "priority": "44",
          "checked": false
        }
      ]
    },
    {
      "title": "Section Settings :",
      "rows": [
        {
          "value": "PROFILE DETAILS",
          "label": "PROFILE DETAILS",
          "priority": "42",
          "checked": false
        },
        {
          "value": "CONTACTS",
          "label": "CONTACTS",
          "priority": "43",
          "checked": false
        },
        {
          "value": "PHYSICIAN LIST",
          "label": "PHYSICIAN LIST",
          "priority": "44",
          "checked": false
        },
        {
          "value": "PHARMACY LIST",
          "label": "PHARMACY LIST",
          "priority": "45",
          "checked": false
        },
        {
          "value": "ELIGIBILITY & PRIOR AUTHENTICATION SECTION",
          "label": "ELIGIBILITY & PRIOR AUTHENTICATION",
          "priority": "46",
          "checked": false
        },
        {
          "value": "MEDICARE INFORMATION SECTION",
          "label": "MEDICARE INFORMATION",
          "priority": "47",
          "checked": false
        }
      ]
    }
  ],
  "toggles": [
    {
      "title": "Transfer Information",
      "name": "cli_print_setting_trans",
      "options": [
        {
          "value": "TRANSFER INFO YES",
          "checked": false
        },
        {
          "value": "TRANSFER INFO NO",
          "checked": true
        }
      ]
    },
    {
      "title": "Payer (Insurance) Details",
      "name": "cli_print_setting_payer",
      "options": [
        {
          "value": "PAYER INFO YES",
          "checked": true
        },
        {
          "value": "PAYER INFO NO",
          "checked": false
        }
      ]
    },
    {
      "title": "Referral Details",
      "name": "cli_print_setting_referral",
      "options": [
        {
          "value": "REFERRAL INFO YES",
          "checked": false
        },
        {
          "value": "REFERRAL INFO NO",
          "checked": true
        }
      ]
    },
    {
      "title": "Schedule Details (Attendance Schedule)",
      "name": "cli_print_setting_att",
      "options": [
        {
          "value": "ATTENDANCE SCHEDULE YES",
          "checked": true
        },
        {
          "value": "ATTENDANCE SCHEDULE NO",
          "checked": false
        }
      ]
    },
    {
      "title": "Schedule Details (Transportation Schedule)",
      "name": "cli_print_setting_transs",
      "options": [
        {
          "value": "TRANSPORTATION SCHEDULE YES",
          "checked": true
        },
        {
          "value": "TRANSPORTATION SCHEDULE NO",
          "checked": false
        }
      ]
    },
    {
      "title": "Food Details (Meal Details)",
      "name": "cli_print_setting_food",
      "options": [
        {
          "value": "FOOD MEAL YES",
          "checked": true
        },
        {
          "value": "FOOD MEAL NO",
          "checked": false
        }
      ]
    },
    {
      "title": "Home Health Details",
      "name": "cli_print_setting_health",
      "options": [
        {
          "value": "HOME HEALTH YES",
          "checked": true
        },
        {
          "value": "HOME HEALTH NO",
          "checked": false
        }
      ]
    },
    {
      "title": "Home Delivered Details",
      "name": "cli_print_setting_deli",
      "options": [
        {
          "value": "HOME DELIVERED YES",
          "checked": true
        },
        {
          "value": "HOME DELIVERED NO",
          "checked": false
        }
      ]
    },
    {
      "title": "Signature Details",
      "name": "cli_print_setting_sign",
      "options": [
        {
          "value": "SIGNATURE YES",
          "checked": true
        },
        {
          "value": "SIGNATURE NO",
          "checked": false
        }
      ]
    },
    {
      "title": "Birthday and Social Security Encrypted",
      "name": "cli_print_setting_encrypt",
      "options": [
        {
          "value": "ENCRYPTED YES",
          "checked": false
        },
        {
          "value": "ENCRYPTED NO",
          "checked": true
        }
      ]
    },
    {
      "title": "LOC",
      "name": "cli_print_setting_loc",
      "options": [
        {
          "value": "LOC YES",
          "checked": false
        },
        {
          "value": "LOC NO",
          "checked": true
        }
      ]
    },
    {
      "title": "Care Manager",
      "name": "cli_print_setting_care_manager",
      "options": [
        {
          "value": "CARE MANAGER YES",
          "checked": false
        },
        {
          "value": "CARE MANAGER NO",
          "checked": true
        }
      ]
    },
    {
      "title": "MARS Details",
      "name": "cli_print_setting_mars_details",
      "options": [
        {
          "value": "MARS DETAILS YES",
          "checked": false
        },
        {
          "value": "MARS DETAILS NO",
          "checked": true
        }
      ]
    }
  ]
} as const
